/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DerivativesOrderSide {
    BUY = 'Buy',
    SELL = 'Sell',
    BUY_OPEN = 'BuyOpen',
    BUY_CLOSE = 'BuyClose',
    SELL_OPEN = 'SellOpen',
    SELL_CLOSE = 'SellClose',
}
